
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { EpisodeWithCategory } from "@/components/admin/episodes/types";

export const useFeaturedEpisodes = () => {
  const [episodes, setEpisodes] = useState<EpisodeWithCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFeaturedEpisodes = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from("episodes")
          .select(`
            *,
            episodes_categories!episodes_category_id_fkey (
              id,
              name,
              color
            )
          `)
          .eq("featured", true)
          .eq("status", "published")
          .order("created_at", { ascending: false })
          .limit(3);

        if (error) throw error;
        
        // Add video_platform field with proper type casting
        const episodesWithPlatform = (data || []).map(episode => {
          const videoPlatform = episode.video_platform === "youtube" || episode.video_platform === "vimeo" 
            ? episode.video_platform 
            : (episode.vimeo_id ? "vimeo" as const : episode.youtube_id ? "youtube" as const : undefined);
          
          return {
            ...episode,
            video_platform: videoPlatform
          };
        });
        
        setEpisodes(episodesWithPlatform);
      } catch (err: any) {
        console.error("Error fetching featured episodes:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedEpisodes();
  }, []);

  return { episodes, loading, error };
};
